import { useState, useEffect, useRef } from 'react';
import { Link } from 'react-router-dom';
import { supabase } from '../supabaseClient';
import './CataloguePreview.css';

import { fallbackProducts } from '../data/fallbackProducts';

export default function CataloguePreview() {
  const [products, setProducts] = useState([]);
  const [loading, setLoading] = useState(true);
  const [hoveredProduct, setHoveredProduct] = useState(null);
  const trackRef = useRef(null);

  useEffect(() => {
    async function fetchRecent() {
      const { data, error } = await supabase
        .from('produits')
        .select('*')
        .order('created_at', { ascending: false })
        .limit(10);

      if (!error && data && data.length > 0) {
        setProducts(data);
      } else {
        // Use local fallback images
        setProducts(fallbackProducts);
      }
      setLoading(false);
    }
    fetchRecent();
  }, []);

  const scroll = (direction) => {
    if (!trackRef.current) return;
    const card = trackRef.current.querySelector('.cp-card');
    if (!card) return;
    const scrollAmount = card.offsetWidth + 16;
    trackRef.current.scrollBy({
      left: direction === 'right' ? scrollAmount : -scrollAmount,
      behavior: 'smooth'
    });
  };

  if (loading) return null;

  return (
    <section className="section catalogue-preview" id="catalogue">
      <div className="container">
        {/* Header */}
        <div className="cp-header" data-aos="fade-up">
          <div className="cp-header__text">
            <span className="section-label">Notre Catalogue</span>
            <h2 className="section-title">
              Suivez<br />
              <em>La Tendance.</em>
            </h2>
          </div>
          <div className="cp-header__actions">
            <div className="cp-arrows">
              <button className="cp-arrow cp-arrow--left" onClick={() => scroll('left')} aria-label="Précédent">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <polyline points="15 18 9 12 15 6" />
                </svg>
              </button>
              <button className="cp-arrow cp-arrow--right" onClick={() => scroll('right')} aria-label="Suivant">
                <svg width="20" height="20" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                  <polyline points="9 6 15 12 9 18" />
                </svg>
              </button>
            </div>
            <Link to="/catalogue" className="cp-view-all">
              VOIR PLUS
              <svg width="14" height="14" viewBox="0 0 24 24" fill="none" stroke="currentColor" strokeWidth="2" strokeLinecap="round" strokeLinejoin="round">
                <polyline points="9 6 15 12 9 18" />
              </svg>
            </Link>
          </div>
        </div>

        {/* Carousel Track */}
        <div className="cp-carousel" data-aos="fade-up" data-aos-delay="100">
          <div className="cp-track" ref={trackRef}>
            {products.map((product) => {
              const hoverImage = product.gallery && product.gallery.length > 0 && product.gallery[0].url ? product.gallery[0].url : null;
              const isHovered = hoveredProduct === product.id && hoverImage;

              return (
              <Link 
                key={product.id} 
                to={`/produit/${product.id}`}
                className="cp-card"
                onMouseEnter={() => setHoveredProduct(product.id)}
                onMouseLeave={() => setHoveredProduct(null)}
              >
                <div className="cp-card__img-wrap">
                  <div
                    className="cp-card__img cp-card__img--main"
                    style={{
                      backgroundImage: `url(${product.image_url})`,
                      opacity: isHovered ? 0 : 1
                    }}
                  />
                  {hoverImage && (
                      <div
                      className="cp-card__img cp-card__img--hover"
                      style={{
                          backgroundImage: `url(${hoverImage})`,
                          opacity: isHovered ? 1 : 0
                      }}
                      />
                  )}
                </div>
                <div className="cp-card__info">
                  <span className="cp-card__category">{product.category}</span>
                  <h3 className="cp-card__name">{product.title}</h3>
                  <span className="cp-card__cta">DÉCOUVRIR LE PRODUIT</span>
                </div>
              </Link>
            )})}
          </div>
        </div>

        {/* Mobile View All */}
        <div className="cp-mobile-cta" data-aos="fade-up">
          <Link to="/catalogue" className="btn btn-primary">
            Voir tout le Catalogue →
          </Link>
        </div>
      </div>
    </section>
  );
}
